import useSWR from 'swr';
import { CamundaProcessService, type ProcessDefinition } from '@/lib/camunda';
import {
  CAMUNDA_PERMISSIONS,
  CAMUNDA_RESOURCE_TYPES,
  CamundaAuthorizationService
} from '@/lib/camunda/authorization-service';
import { categorizeProcesses } from '@/lib/process-registry';

const AUTHORIZED_PROCESSES_KEY = 'authorized-processes';

const fetchAuthorizedProcesses = async (): Promise<ProcessDefinition[]> => {
  const allProcesses = await CamundaProcessService.getProcessDefinitions();
  return CamundaAuthorizationService.getAuthorizedResources({
    permissionName: CAMUNDA_PERMISSIONS.CREATE_INSTANCE,
    resourceName: 'PROCESS_DEFINITION',
    resourceType: CAMUNDA_RESOURCE_TYPES.PROCESS_DEFINITION,
    allResources: allProcesses,
  });
};

export function useAuthorizedProcesses(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR(
    enabled ? AUTHORIZED_PROCESSES_KEY : null,
    fetchAuthorizedProcesses,
    {
      dedupingInterval: 15000,
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
    }
  );

  const authorizedProcesses = data ?? [];
  const categorizedProcesses = categorizeProcesses(authorizedProcesses);

  return {
    authorizedProcesses,
    categorizedProcesses,
    loading: isLoading,
    error: error instanceof Error ? error.message : null,
    reload: () => mutate(),
  };
}
